import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';


const profileAPI = createApi({
    reducerPath: "profileAPI",
    baseQuery,
    endpoints: (builder) => ({
        getUserProfile: builder.query({
            query: () => ({
                url: `staff/profile`,
                method: "GET",
            }),
            transformResponse: (response) => response,
            providesTags: ["profile"],
            keepUnusedDataFor: 0,
        }),
        getUserRole: builder.mutation({
            query: () => ({
                url: `staff/profile`,
                method: "GET",
            }),
            transformResponse: (response) => response.role,
            providesTags: ["role"],
        }),
        updateProfile: builder.mutation({
            query: ({ body }) => ({
                url: `staff/profile`,
                method: "PUT",
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ["profile"],
        }),
        getUploadURL: builder.mutation({
            query: ({extension,type}) => ({
                url: `staff/auth/upload?extension=${extension}&uploadType=${type}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        
    }),
});

export const { useGetUserProfileQuery, useGetUserRoleMutation, useUpdateProfileMutation, useGetUploadURLMutation } = profileAPI;
export default profileAPI;
